module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0053.jpg?v=96669ef4";